// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { targetCrosshairs16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-target-crosshairs': IconTargetCrosshairs;
    }
}

/**
 * The icon component for the 'targetCrosshairs' icon
 */
export class IconTargetCrosshairs extends IconSvg {
    public constructor() {
        super(targetCrosshairs16X16);
    }
}

registerIconSvg('icon-target-crosshairs', IconTargetCrosshairs);
export const iconTargetCrosshairsTag = 'nimble-icon-target-crosshairs';
